export default "__VITE_ASSET__BPBoLvp0__"